import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'code-variable', 'CodeVariable', [["path",{"d":"M4 10a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -4"}]]);